import { apiClient } from "@/services/api";

export default {
  submitTourInquiry(notes) {
    return apiClient.post("/market-tours", { notes: notes });
  }
};
